let FulfillmentNode = (function () {

  let setOrderInfo = function (uid, type) {
    localStorage.setItem('fulfillmentOrderInfo', JSON.stringify({ uid: uid, type: type }));
  };

  let getOrderInfo = function () {
    return JSON.parse(localStorage.getItem('fulfillmentOrderInfo'));
  };

  let setCartItem = function (cartItems) {
    clearCartItem()
    localStorage.setItem('cartItemFulfillment', JSON.stringify(cartItems));
  };

  let getCartItem = function () {
    let cartItem = JSON.parse(localStorage.getItem('cartItemFulfillment'));
    return cartItem || []
  };

  let clearCartItem = function () {
    localStorage.removeItem("cartItemFulfillment");
  };

  let setData = function (data) {
    clearData()
    localStorage.setItem('dataFulfillment', JSON.stringify(data));
  };

  let getData = function () {
    let data = JSON.parse(localStorage.getItem('dataFulfillment'));
    return data || []
  };

  let clearData = function () {
    localStorage.removeItem("dataFulfillment");
  };

  let setToken = function (data) {
    localStorage.setItem('tokenFulfillment', JSON.stringify(data));
  };

  let getToken = function () {
    return JSON.parse(localStorage.getItem('tokenFulfillment'));
  };

  let clearUploadedPhotos = function () {
    localStorage.removeItem("uploadPhotos");
  }

  let addUploadedPhotos = function (data) {
    if(data) {
      let photos = getUploadedPhotos() || []
      photos.push(data)
      localStorage.setItem('uploadPhotos', JSON.stringify(photos));
    }
  };

  let getUploadedPhotos = function () {
    return JSON.parse(localStorage.getItem('uploadPhotos'));
  };

  return {
    setOrderInfo: setOrderInfo,
    getOrderInfo: getOrderInfo,
    setCartItem: setCartItem,
    setData: setData,
    getData: getData,
    clearData: clearData,
    getCartItem: getCartItem,
    clearCartItem: clearCartItem,
    setToken: setToken,
    getToken: getToken,
    clearUploadedPhotos: clearUploadedPhotos,
    addUploadedPhotos: addUploadedPhotos,
    getUploadedPhotos: getUploadedPhotos,
  }
})();

export default FulfillmentNode;
